import { driver } from 'driver.js';
import '../main.css';
import 'driver.js/dist/driver.css';
import { mssReportModalToggle } from '@/redux/actions/mssReportQueueActions';

export const reportDriverPbj = (dispatch) => {
  const driverObj = driver({
    showProgress: true,
    nextBtnText: 'Next',
    prevBtnText: 'Previous',
    doneBtnText: 'Done',
    popoverClass: 'driverjs-theme',
    steps: [
      {
        element: '.createReport',
        popover: {
          title: 'Create New Notification',
          description:
            'Use this feature to create a new notification. You can customize the message, audience, and timing to ensure effective communication.',
          side: 'left',
          align: 'start',
        },
      },
      {
        element: '.allReports',
        popover: {
          title: 'Notifications Overview',
          description:
            'This table provides an overview of all notifications created within the system. You can view, edit, or delete notifications as needed.',
          side: 'left',
          align: 'start',
          onNextClick: () => {
            dispatch(mssReportModalToggle());
            driverObj.destroy();
          },
        },
      },
    ],
  });
  return driverObj;
};
export default reportDriverPbj;
